export enum Bool {
    True = <any>true,
    False = <any>false
}

(Bool as any).__typeName = "Bool";